import {
    AbstractControl,
    AbstractControlOptions,
    FormControl,
    FormGroup,
    ValidationErrors,
    Validators
} from '@angular/forms';
import { Kpi } from '@tran-monorepo/interfaces/applications';
import { CustomValueSelectItem } from '../custom-value-select/custom-value-select-item.type';

export type KpiSelectorFormGroup = FormGroup<{
    selection: FormControl<CustomValueSelectItem<Kpi>[]>;
    definition: FormControl<string>;
    startValue: FormControl<number | null>;
    startValueUnit: FormControl<string>;
    targetValue: FormControl<number | null>;
    targetValueUnit: FormControl<string>;
}>;

export function createKpiSelectorForm(options?: AbstractControlOptions): KpiSelectorFormGroup {
    const isRequired = options?.validators === Validators.required;
    const valueValidators = isRequired ? Validators.required : [];

    return new FormGroup(
        {
            selection: new FormControl<CustomValueSelectItem<Kpi>[]>([], {
                nonNullable: true,
                validators: valueValidators
            }),
            definition: new FormControl('', { nonNullable: true, validators: valueValidators }),
            startValue: new FormControl<number | null>(null, valueValidators),
            startValueUnit: new FormControl('', { nonNullable: true, validators: valueValidators }),
            targetValue: new FormControl<number | null>(null),
            targetValueUnit: new FormControl('', { nonNullable: true })
        },
        { validators: isRequired ? Validators.required : [] }
    );
}

export function kpiSelectorRequired(control: AbstractControl): ValidationErrors | null {
    const form = control as KpiSelectorFormGroup;
    return form.controls.selection.value.length > 0 ? null : { kpiRequired: true };
}
